import { PanelsTopLeftIcon } from "lucide-react";
import { cn } from "~/lib/utils";

/** First visible letter/digit of the project name, for the avatar fallback. */
export function resolveProjectInitial(projectName: string | null | undefined): string | null {
  if (!projectName) return null;
  const match = projectName.match(/[\p{L}\p{N}]/u);
  return match ? match[0]!.toUpperCase() : null;
}

/**
 * Shared placeholder for a project icon that has no favicon image: a brand-tinted
 * letter-avatar of the project name, or a generic glyph when the name has no
 * usable letter/digit. Used by both local favicon discovery and the canonical
 * CMMD project identity renderer so every project remains distinct.
 */
export function ProjectLetterAvatar(input: {
  readonly projectName: string | null | undefined;
  readonly className?: string | undefined;
}) {
  const initial = resolveProjectInitial(input.projectName);
  if (initial !== null) {
    return (
      <span
        aria-hidden="true"
        data-project-icon="initial"
        className={cn(
          "inline-flex size-3.5 shrink-0 items-center justify-center rounded-[3px] bg-primary/15 text-[10px] font-semibold leading-none text-primary",
          input.className,
        )}
      >
        {initial}
      </span>
    );
  }

  return (
    <span
      aria-hidden="true"
      data-project-icon="fallback"
      className={cn(
        "inline-flex size-3.5 shrink-0 items-center justify-center rounded-[3px] border border-border/70 bg-muted/30 text-muted-foreground/65",
        input.className,
      )}
    >
      <PanelsTopLeftIcon className="size-[72%]" />
    </span>
  );
}
